/*
 * Copyright (c) 2023-2025. Haodong JU
 */

import { FireBaseAuth, FireBaseStore } from '@/model/firebase/google-fire-base'
import { docContentOf, resultOf } from '@/model/firebase/queryUtils'
import { collection, doc, query, setDoc } from 'firebase/firestore'
import router from '@/model/global/router'
import { enterStore, useStore } from '@/model/dataLayer/api/SaaS/storeService'
import { lastRoute, resetLastRoute } from '@/main'
import { getAllStoreIdForUser, getUserAndStoreRelationByDeviceId } from '@/model/dataLayer/api/SaaS/subscriptionService'
import GlobalConfig, { getOfflineUrl, Remember, requireOfflineMode } from '@/model/global/GlobalSettings'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'
import { getActiveCodes } from '@/model/firebase/activeUtils'
import { sleep } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import hillo from 'hillo'
import store from '@/model/global/store'

const userPrimaryStorePath = 'userPrimaryStore'
const userPinCode = 'userPinCode'
const userPinCodeStatus = 'userPinCodeStatus'

// export async function login () {
//   await determinedActivationStep()
// }

export async function getActiveProductCode (deviceId = '') {
  let realDeviceId = ''
  realDeviceId = deviceId || await getCurrentDeviceId()
  return await getActiveCodes(realDeviceId)
}

export async function determinedActivationStep () {
  if (requireOfflineMode()) {
    const deviceId = await getCurrentDeviceId(getOfflineUrl() + '/PHP/')
    await useStore(deviceId, false)
    await gotoLastRoute()
  } else {
    if (router.currentRoute.name === 'cancel' || router.currentRoute.name === 'success') {
      return
    }
    if (Remember.shouldWait5Seconds) {
      await sleep(5 * 1000)
      Remember.shouldWait5Seconds = false
    }

    const mainStoreDevice = (await getUserCurrentStoreInfo())
    if (mainStoreDevice) {
      GlobalConfig.DeviceId = mainStoreDevice.currentStoreId
      const allDeviceSubscription = await getSubscriptionByCloudV2WithDeviceId(mainStoreDevice.currentStoreId)
      if (mainStoreDevice.currentStoreId > '6100' && mainStoreDevice.currentStoreId !== '9002') {
        const userStoreInfo = await getUserAndStoreRelationByDeviceId(mainStoreDevice.currentStoreId)
        const baseProduct = allDeviceSubscription.find(it => it.productCode === 'base')
        if (!baseProduct && !userStoreInfo.admin) {
          await router.push('/needOpenDevice')
          return
        }
        if (userStoreInfo.admin) {
          store.commit('getAdminTest', { test: true })
        } else {
          store.commit('getAdminTest', { test: false })
        }
      }
      await enterStore(mainStoreDevice.currentStoreId)
      if (mainStoreDevice.notReady) {
        await router.push('/waiting-activate')
      } else {
        await gotoLastRoute()
      }
    } else {
      const alreadyAddedStore = await getAllStoreIdForUser()
      if (alreadyAddedStore.length > 0) {
        await saveUserCurrentStoreInfo(alreadyAddedStore[0])
        await useStore(alreadyAddedStore[0], false)
      } else {
        await router.push('/SaaS')
      }
    }
  }

  console.timeEnd('saasTimer')
}

export async function gotoLastRoute (type = '') {
  let name = lastRoute
  if (!lastRoute || lastRoute === 'LoadingPage' || lastRoute === 'error_page') {
    if (type === 'Shop') {
      name = 'dashboard'
    } else {
      name = 'VipCenter'
    }
  }
  resetLastRoute()
  if (name === router.currentRoute.name) {
    await router.push({ name: 'LoadingPage' })
  }

  await router.push({ name })
}

export async function saveUserCurrentStoreInfo (storeId, baseUrl = '') {
  await setDoc(doc(FireBaseStore, userPrimaryStorePath, getCurrentUserId()), {
    currentStoreId: storeId,
    baseUrl
  })
}

export async function getUserCurrentStoreInfo () {
  try {
    return (await docContentOf(doc(FireBaseStore, userPrimaryStorePath, getCurrentUserId())))
  } catch (e) {
    console.log('Not Login', e)
    return ''
  }
}

export async function getCurrentStoreId () {
  return (await getUserCurrentStoreInfo())?.currentStoreId.toString() ?? null
}

export async function getPinCode () {
  return (await docContentOf(doc(FireBaseStore, userPinCode, getCurrentUserId())))
}

export async function usePinCode (pinCodeStatus) {
  return await setDoc(doc(FireBaseStore, userPinCodeStatus, getCurrentUserId()), { pinCodeStatus })
}
/**
 * @returns {string | undefined}
 */
export function getCurrentUserId () {
  return FireBaseAuth.currentUser?.uid
}

export async function getAllSubscriptionForCurrentStore () {
  const deviceId = await getCurrentStoreId()
  return await resultOf(query(collection(FireBaseStore, 'saas-store-subscription', deviceId.toString(), 'subscriptions')))
}

export async function getShopQR (shopId) {
  return await hillo.get('https://cloud-v2.aaden.io/report/shop/' + shopId, {}, { silent: true })
}

export async function getALLSubscriptionByCloudV2 () {
  return await hillo.get('https://cloud-v2.aaden.io/subscriptions/all', {})
}

export async function getSubscriptionByCloudV2WithDeviceId (deviceId) {
  return (await hillo.get('https://cloud-v2.aaden.io/subscriptions/by-device/' + deviceId, {})).filter(it => it.status === 'trialing' || it.status === 'active')
}
